import Vue from "vue";
// import store from "@/store"
import draggable from "vuedraggable";
import Properties from "@/components/form_elements_expression/properties/Properties.vue";

import FormElementTitle from "@/components/form_elements_expression/formElements/FormElementTitle";
import FormElementExplain from "@/components/form_elements_expression/formElements/FormElementExplain";
import FormElementExample from "@/components/form_elements_expression/formElements/FormElementExample";
import FormElementIllustration from "@/components/form_elements_expression/formElements/FormElementIllustration";
import FormElementSentenceStructure from "@/components/form_elements_expression/formElements/FormElementSentenceStructure";

import vm from "@/main";

export const FormBuilder = new Vue({
  components: {
    draggable,
    Properties,
    FormElementTitle,
    FormElementExplain,
    FormElementExample,
    FormElementIllustration,
    FormElementSentenceStructure,
  },
  data() {
    return {
      fields: [
        {
          fieldType: "FormElementTitle",
          type: "text",
          text: "タイトル",
          key: "Title",
          disabled: true,
          require: false,
          id: "",
          value: {},
          isType: "TEXT",
          alignItems: "center",
          color: "#69BE5B",
        },
        {
          fieldType: "FormElementExplain",
          type: "text",
          text: "説明",
          key: "Explain",
          disabled: true,
          require: false,
          id: "",
          value: {},
          cols: 12,
        },
        {
          fieldType: "FormElementExample",
          type: "text",
          text: "例文",
          key: "Example",
          disabled: true,
          require: false,
          id: "",
          value: {},
          file: null,
          cols: 12,
        },
        {
          fieldType: "FormElementIllustration",
          type: "image",
          text: "挿絵データ",
          key: "Illustration",
          disabled: true,
          require: false,
          id: "",
          file: null,
          cols: 12,
        },
      ],
    };
  },
  methods: {
    deleteElement(index, form) {
      this.$delete(form, index);
      vm.$store.activeFieldExpression = {};
    },

    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },

    editElementProperties(field) {
      vm.$store.activeFieldExpression = field;
    },
  },
});
